import { DomainError } from "../errors.js";
function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}
const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function parts(date) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);
    const year = Number(match?.[1]);
    const month = Number(match?.[2]);
    const day = Number(match?.[3]);
    const monthDays = month === 2 && isLeapYear(year) ? 29 : (DAYS_IN_MONTH[month - 1] ?? 0);
    if (match === null || month < 1 || month > 12 || day < 1 || day > monthDays) {
        throw new DomainError('invalid-moment', `"${date}" is not a calendar date (YYYY-MM-DD).`, { date });
    }
    return { year, month, day };
}
/** Whole years between a date of birth and a day. A day before the birth is age 0, not negative. */
export function ageOn(dateOfBirth, on) {
    const born = parts(dateOfBirth);
    const today = parts(on);
    let age = today.year - born.year;
    // The birthday this year, with 29 February moved to 1 March when there is no 29th.
    let birthdayMonth = born.month;
    let birthdayDay = born.day;
    if (born.month === 2 && born.day === 29 && !isLeapYear(today.year)) {
        birthdayMonth = 3;
        birthdayDay = 1;
    }
    if (today.month < birthdayMonth || (today.month === birthdayMonth && today.day < birthdayDay))
        age -= 1;
    return Math.max(0, age);
}
/** The bar a player must clear in a class: the venue's minimum age or the class's limit, whichever is higher. */
export function minimumAgeFor(venueMinimumAge, classAgeLimit) {
    return Math.max(venueMinimumAge, classAgeLimit ?? 0);
}
/**
 * spec/05 §3.2 check 5, with `players.minAge`. `today` is the venue's local date at the start.
 * A minimum of 0 — no limit anywhere — lets anyone play, with or without a date of birth.
 */
export function classAgeCheck(input) {
    const minimumAge = minimumAgeFor(input.venueMinimumAge, input.classAgeLimit);
    if (minimumAge <= 0)
        return { allowed: true };
    if (input.dateOfBirth === null)
        return { allowed: false, minimumAge, reason: 'no_date_of_birth' };
    return ageOn(input.dateOfBirth, input.today) >= minimumAge
        ? { allowed: true }
        : { allowed: false, minimumAge, reason: 'too_young' };
}
//# sourceMappingURL=age.js.map